<template>
  <nav v-bind:class="{ 'top-nav': true, 'open': menuOpen }">
    <div class="menu-button">
      <a href="#" v-on:click="toggleMenu">
        <fa v-if="menuOpen" :icon="['fad', 'times']" />
        <fa v-if="!menuOpen" :icon="['fad', 'bars']" />
      </a>
    </div>
    <div class="menu">
      <h2 class="site-title">CW</h2>
      <router-link v-on:click.native="closeMenu" to="/home">Home</router-link>
      <router-link v-on:click.native="closeMenu" to="/gallery">Gallery</router-link>
      <div class="initial-divider">CW</div>
      <router-link v-on:click.native="closeMenu" to="/projects">Projects</router-link>
      <router-link v-on:click.native="closeMenu" to="/blog">Blog</router-link>
    </div>
  </nav>
</template>

<style lang="stylus">

</style>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState(['menuOpen'])
  },
  methods: {
    toggleMenu (e) {
      e.preventDefault()
      this.$store.commit('toggleMenu')
    },
    closeMenu (e) {
      e.preventDefault()
      this.$store.commit('closeMenu')
    }
  }
}
</script>
